import { cloneDeep } from 'lodash';
import { transparentize } from 'polished';
import { colors } from './colors';
import {
  helperDarkGray,
  palette,
  primaries,
  rebrand,
  rebrandBlue,
  rebrandFushia,
  rebrandNude,
  rebrandPurple,
  rebrandSuccess,
  rebrandYellow,
  shadowColor,
  shadowSize,
} from './palette';
import defaultTheme from './themedefault';
import { CustomTheme } from './types';

const theme = cloneDeep(defaultTheme) as unknown as CustomTheme;

theme.name = 'atsDark';

theme.palette = {
  ...theme.palette,
  ...palette,
  rebrand,
  rebrandBlue,
  rebrandNude,
  rebrandPurple,
  rebrandFushia,
  rebrandYellow,
  rebrandSuccess,
  helperDarkGray,
};

theme.palette.primary = theme.palette.primary.concat(primaries);

theme.palette.border = [
  theme.palette.primary[32], // 0: Border
  theme.palette.dark[3], // 1: Job content
  theme.palette.dark[3], // 2: acl wrapper
];

theme.palette.background = [
  theme.palette.dark[4], // 0: default text color
  theme.palette.primary[26], // 1: rating star color
  theme.palette.dark[1], // 2: header background
  theme.palette.dark[1], // 3: left menu background
  theme.palette.primary[28], // 4: animated loader color
  theme.palette.dark[3], // 5: comment header background
  theme.palette.dark[3], // 6: flowpaper toolbar background
  theme.palette.dark[2], // 7: flowpaper viewer background
  theme.palette.primary[14], // 8: flowpaper toolbar button background
  theme.palette.dark[2], // 9: single job background
  theme.palette.dark[1], // 10: layout wrapper background
  theme.palette.dark[2], // 11: main content background
  theme.palette.dark[2], // 12: application background
  theme.palette.dark[3], // 13: application attachment list background
  theme.palette.dark[2], // 14: profile list background
  theme.palette.dark[2], // 15: profile list item background
  theme.palette.dark[1], // 16: profile list rejected item background
  theme.palette.dark[3], // 17: profile list item hover background
  theme.palette.dark[2], // 18: right sidebar background
  theme.palette.primary[18], // 19: sandwich color
  theme.palette.dark[2], // 20: searchbox icon
  theme.palette.dark[3], // 21: dropdown popover background
  theme.palette.dark[3], // 22: sortwrapper background
  theme.palette.blue[2], // 23: initials circle background
  theme.palette.dark[2], // 24: status menu background
  theme.palette.dark[2], // 25: drag item background
  theme.palette.dark[2], // 26: job sort background
  theme.palette.dark[1], // 27: aside header background
  theme.palette.primary[35], // 28: application list item selected
  theme.palette.dark[2], // 29: initials circle
  theme.palette.primary[37], // 30: left menu item selected
  theme.palette.dark[3], // 31: button background
  theme.palette.dark[6], // 32: checkbox background
  theme.palette.dark[3], // 33: expand handle background
  theme.palette.dark[3], // 34: dropdown background
  theme.palette.dark[3], // 35: application search bar background
  theme.palette.primary[37], // 36: timeline item background
  theme.palette.dark[1], // 37: main padding background
  theme.palette.primary[63], // 38: job status background
  theme.palette.dark[3], // 39: team acl wrapper background
  theme.palette.dark[2], // 40: modal background
  theme.palette.dark[3], // 41: preselection background
  theme.palette.dark[2], // 42: preselection correct answer background
  theme.palette.dark[1], // 43: greybox background
  theme.palette.dark[3], // 44: searchbox input background
  theme.palette.dark[1], // 45: new tag background
  theme.palette.dark[3], // 46: input background
  theme.palette.dark[3], // 47: input disabled background
  theme.palette.dark[3], // 48: profile list item option background
  theme.palette.dark[2], // 49: flowpaper zoom button background
  theme.palette.dark[2], // 50: applications selection header background
  theme.palette.dark[3], // 51: userchip background
  theme.palette.dark[3], // 52: tabs background
  theme.palette.dark[2], // 53: no results background
  theme.palette.primary[35], // 54: renew button background
  theme.palette.dark[3], // 55: job tag background
  theme.palette.primary[55], // 56: table hover background
  theme.palette.primary[55], // 57: input addon background
  theme.palette.primary[55], // 58: profile image placeholder background
  theme.palette.dark[3], // 59: select box background
  theme.palette.primary[35], // 60: banner background
  theme.palette.rebrand[1], // 61: primary background
  theme.palette.primary[35], // 62: contact button background
  theme.palette.primary[35], // 63: unread background
  transparentize(0.95, theme.palette.primary[17]), // 64: job status ordering background
  theme.palette.dark[5], // 65: job button hover background
  theme.palette.dark[2], // 66: dropdown hover background
  theme.palette.dark[2], // 67: select tag background
  theme.palette.dark[3], // 68: select clear button under X
  theme.palette.dark[3], // 69: tag background
  theme.palette.primary[58], // 70: alert error background
  theme.palette.primary[63], // 71: scroll background
  theme.palette.dark[3], // 72: team temp alert info background
  theme.palette.primary[67], // 73: bulk actions background
  theme.palette.dark[3], // 74: message background
  theme.palette.dark[3], // 75: alert info background
  theme.palette.primary[70], // 76: profile promo background
  theme.palette.dark[3], // 77: tooltip background
  theme.palette.dark[2], // 78: notification background
  theme.palette.primary[78], // 79: notification feature background
  theme.palette.dark[3], // 80: cover letter background
  theme.palette.dark[3], // 81: ordered job background
  theme.palette.dark[3], // 82: page selector button
  theme.palette.dark[3], // 83: ad type background
  theme.palette.dark[2], // 84: radio background
  theme.palette.dark[3], // 85: radio button selected background
  theme.palette.dark[3], // 86: InputNumber background
  theme.palette.dark[7], // 87: InputNumber background (active)
  theme.palette.dark[3], // 88: Steps
  theme.palette.dark[3], // 89: Online interviews header
  theme.palette.dark[1], // 90: email template variable background
  theme.palette.primary[43], // 91: photo background
  theme.palette.primary[63], // 92 CV database highlight background
  theme.palette.primary[17], // 93 standout orange for loyaltyreport
  theme.palette.rebrand[1], // 94 standout purple for loyaltyreport
  theme.palette.primary[86], // 95 section background color
  theme.palette.dark[2], // 96 comment modal background
  theme.palette.dark[2], // 97: continue job notification background
  theme.palette.rebrandBlue[7], // 98 advanced search apply button color
  theme.palette.rebrandBlue[6], // 99 advanced search apply button higlight color
  theme.palette.dark[7], // 100 new header background color
  theme.palette.dark[2], // 101 create profile modal background
  theme.palette.dark[1], // 102 create profile modal button background
  theme.palette.dark[2], // 103 create profile modal disabled button background
  theme.palette.rebrandFushia[6], // 104: search button background
  theme.palette.rebrandFushia[5], // 105: search button background (hover)
  theme.palette.dark[1], // 106: candidate profile modal header background
  theme.palette.dark[3], // 107: actions background
  theme.palette.dark[2], // 108: select item background
  theme.palette.dark[2], // 109: project container background
  theme.palette.dark[1], // 110: job background color
  theme.palette.dark[3], // 111: job placeholder background color
  theme.palette.dark[8], // 112: placeholder job hover color
  theme.palette.dark[2], // 113: serial number background
  theme.palette.rebrandBlue[1], // 114: serial number highlighted background
  theme.palette.dark[2], // 115: light panel background
  theme.palette.dark[3], // 116: light panel card background
  theme.palette.dark[2], // 117: social posting size shade
  theme.palette.dark[1], // 118: social posting checked
  theme.palette.primary[90], // 119: social posting description
  theme.palette.dark[1], // 120: package checked
  theme.palette.dark[1], // 121: job preview pill background
  theme.palette.primary[14], // 122: site logo background
  theme.palette.primary[86], // 123: profile editor secondary elements background
  theme.palette.rebrandYellow[8], // 124: hint warning variant
  theme.palette.primary[95], // 125: profile editor card
  theme.palette.dark[2], // 126: profile report card background
  theme.palette.dark[3], // 127: profile report row hover background
  theme.palette.rebrandYellow[3], // 128: ad package yellow pill background
  theme.palette.rebrandYellow[0], // 129: accented modal header and hover
  transparentize(0.8, theme.palette.rebrandYellow[3]), // 130: tag background
  theme.palette.grey[0], // 131: secondary tag background
  theme.palette.dark[1], // 132: upsale section background
];

theme.palette.foreground = [
  theme.palette.dark[5], // 0: default text color
  theme.palette.primary[26], // 1: rating star color
  theme.palette.dark[6], // 2: left menu link color
  theme.palette.dark[6], // 3: left menu highlight link color
  theme.palette.dark[6], // 4: left menu selected link color
  theme.palette.dark[6], // 5: left menu link hover color
  theme.palette.dark[6], // 6: initials circle
  theme.palette.primary[17], // 7: divider text
  theme.palette.dark[6], // 8: default button text
  theme.palette.dark[6], // 9: faded text color
  theme.palette.dark[6], // 10: status text color
  theme.palette.dark[6], // 11: profile list item option text color
  theme.palette.primary[45], // 12: dropdown hover color
  theme.palette.primary[47], // 13: disabled input text color
  theme.palette.primary[49], // 14: application list email
  theme.palette.primary[50], // 15: phone number color
  theme.palette.primary[35], // 16: promo divider text color
  theme.palette.primary[14], // 17: renew button text
  theme.palette.dark[5], // 18: hightlight color text
  theme.palette.dark[6], // 19: job tag text color
  theme.palette.dark[5], // 20: select text
  theme.palette.dark[6], // 21: banner text
  theme.palette.primary[35], // 22: primary color text
  theme.palette.primary[32], // 23: unread text
  theme.palette.primary[17], // 24: generic highlights
  theme.palette.dark[5], // 25: comment time
  theme.palette.dark[6], // 26: comment highlight
  theme.palette.rebrand[1], // 27: dark mode switch color
  theme.palette.primary[72], // 28: new application notification
  theme.palette.dark[5], // 29: notification text
  theme.palette.primary[76], // 30: notification feature icon
  theme.palette.primary[17], // 31: notification new application icon
  theme.palette.primary[74], // 32: notification feature text
  theme.palette.primary[14], // 33: package promo text
  theme.palette.dark[3], // 34: subtle divider
  theme.palette.dark[5], // 35: page selector button
  theme.palette.rebrand[1], // 36: radio primary color
  theme.palette.dark[5], // 37: radio button selected foreground
  transparentize(0.6, theme.palette.dark[5]), // 38: radio focused shadow color
  theme.palette.dark[7], // 39: radio border color
  transparentize(0.5, theme.palette.dark[5]), // 40: InputNumber focused shadow color
  theme.palette.primary[45], // 41: generic link color
  theme.palette.primary[81], // 42: antd blue
  theme.palette.dark[3], // 43: job status foreground
  theme.palette.primary[17], // 44: job status ordered foreground
  theme.palette.blue[2], // 45: email template variable foreground
  theme.palette.red[4], // 46: template editor invalid color
  theme.palette.dark[5], // 47 CV database highlight foreground
  theme.palette.primary[84], // 48 custom class for standout-text
  theme.palette.primary[17], // 49 standout orange for loyaltyreport
  theme.palette.dark[6], // 50 standout purple for loyaltyreport
  theme.palette.primary[88], // 51 border color for loyaltyreport
  theme.palette.dark[5], // 52: secondary color text
  theme.palette.dark[4], // 53 comment modal text color
  theme.palette.primary[81], // 54 comment modal text hover color
  theme.palette.dark[5], // 55: continue job notification title
  theme.palette.dark[5], // 56: continue job notification hide button text
  theme.palette.primary[81], // 57: continue job notification icon
  theme.palette.dark[4], // 58: application list item unread text
  theme.palette.rebrandYellow[2], // 59 secondary button highlight color
  theme.palette.dark[5], // 60 secondary button text color
  theme.palette.rebrandBlue[3], // 61 active input text color
  theme.palette.rebrandBlue[4], // 62 advanced search label color
  theme.palette.rebrandBlue[5], // 63 advanced search link button text color highlight
  theme.palette.dark[4], // 64: search & advanced search button text color
  theme.palette.grey[1], // 65: side-note or acccent
  theme.palette.rebrandBlue[4], // 66: candidate profile card (seen)
  theme.palette.green[2], // 67: candidate profile card (unlocked)
  theme.palette.rebrandFushia[3], // 68: candidate profile card icons
  theme.palette.rebrandBlue[4], // 69: info accents and modal header
  theme.palette.rebrandBlue[4], // 70: create profile heading text color
  theme.palette.dark[5], // 71: new header text color
  theme.palette.rebrandBlue[4], // 72: profile list profile name
  theme.palette.dark[5], // 73: create profile modal title
  theme.palette.rebrandBlue[7], // 74: create profile modal button text
  theme.palette.dark[3], // 75: create profile modal button border color
  theme.palette.rebrand[1], // 76: create profile modal cancel
  theme.palette.rebrandBlue[4], // 77: link button text color
  theme.palette.rebrandFushia[3], // 78: icons colors and highlights
  theme.palette.rebrandFushia[6], // 79: modal close button color
  theme.palette.rebrandFushia[5], // 80: close button (hover) & secondary button
  theme.palette.rebrandBlue[4], // 81: button with brand illustration
  theme.palette.grey[2], // 82: descriptions
  theme.palette.grey[4], // 83: date info with less accent
  theme.palette.grey[3], // 84: disabled icons color
  theme.palette.rebrandBlue[4], // 85: select hover text color
  theme.palette.primary[17], // 86: project and job brand color variation
  theme.palette.rebrandBlue[4], // 87: project pencil icon, show more icon
  theme.palette.rebrandBlue[5], // 88: project actions color
  theme.palette.dark[6], // 89: greyed out job text
  theme.palette.primary[15], // 90: candidate count text color
  theme.palette.rebrandBlue[4], // 91: placeholder job hover text color
  theme.palette.primary[91], // 92: publish and renew buttons color
  theme.palette.primary[92], // 93: publish button hover color
  theme.palette.rebrandBlue[5], // 94: application comments icon color
  theme.palette.primary[17], // 95: application buttons and actions
  theme.palette.rebrandYellow[3], // 96: link accent color
  theme.palette.rebrandYellow[2], // 97: link accent color hover
  theme.palette.dark[6], // 98: serial number text
  theme.palette.rebrandBlue[6], // 99: serial number highlighted text
  theme.palette.dark[6], // 100: heading color
  theme.palette.dark[6], // 101: light text color
  theme.palette.dark[7], // 102: social posting description
  theme.palette.rebrandBlue[4], // 103: profile editor blue accent
  theme.palette.helperDarkGray[0], // 104: profile editor status bar
  theme.palette.rebrandFushia[6], // 105: new button primary color
  theme.palette.rebrandBlue[4], // 106: new button secondary color
  theme.palette.grayscale[0], // 107: disabled new button background color
  theme.palette.dark[1], // 108: post editor control button active
  theme.palette.rebrandYellow[3], // 109: profile editor status bar dirty
  theme.palette.primary[14], // 110: profile editor status bar profile link
  theme.palette.grey[3], // 111: profile editor notice text
  theme.palette.rebrandYellow[5], // 112: hint warning variant text
  theme.palette.dark[1], // 113: profile editor card hover
  theme.palette.rebrandBlue[6], // 114: profile report views icon poslovi
  theme.palette.rebrandBlue[6], // 115: profile report views icon helloworld
  theme.palette.primary[14], // 116: profile report views icon helloworld
  theme.palette.grey[4], // 117: secondary tag text color
  theme.palette.rebrandBlue[7], // 118: link color
  theme.palette.rebrandBlue[5], // 119: link color hover
  theme.palette.rebrand[1], // 120: topbar dropdown item hover (.isoDropdownLink:hover)
  theme.palette.rebrandBlue[6], // 121: single application basic info icon colors
];

theme.palette.fontWeight = [
  '700', // 0: left menu highlight
];

theme.palette.borderRadius = [
  '10px', // 0: application wrapper
  '30px', // 1: button
  '10px', // 2: profile list
  '10px', // 3: right sidebar
  '0px 20px 20px 0px', // 4: left menu selected item
  '0px 20px 20px 0px', // 5: sort wrapper
  '20px 0px 0px 20px', // 6: filter wrapper
  '20px', // 7: last child filter wrapper
  '20px 0px 0px 20px', // 8: application search bar wrapper
  '20px 20px 20px 20px', // 9: application search bar no sort wrapper
  '20px 20px 20px 20px', // 10: filter no sort wrapper
  '0', // 11: package order form container
  '0', // 12: invoices (mobile)
  '8px', // 13: candidate search components
  '4px', // 14: candidate search buttons
  '4px', // 15: new design form elements
  '16px', // 16: job preview pill
  '8px', // 17: profile report card
];

theme.palette.borderColor = [
  theme.palette.dark[6], // 0: button border
  theme.palette.primary[37], // 1: profile list item button border
  theme.palette.primary[51], // 2: profile header bottom border
  theme.palette.dark[1], // 3: job tag border color
  theme.palette.dark[2], // 4: profile image placeholder border
  theme.palette.primary[55], // 5: select box border
  theme.palette.primary[61], // 6: tab border
  theme.palette.primary[73], // 7: new application notification
  theme.palette.primary[75], // 8: notification
  theme.palette.dark[2], // 9: page selector button
  theme.palette.dark[2], // 10: simple input
  theme.palette.rebrandYellow[2], // 11: secondary button border color (hover)
  theme.palette.dark[6], // 12: secondary button border color
  theme.palette.rebrandBlue[3], // 13: input border highlight color
  theme.palette.grey[2], // 14: candidate profile card divider
  theme.palette.rebrandBlue[4], // 15: profile list CTA
  theme.palette.rebrandFushia[6], // 16: secondary button
  theme.palette.rebrandFushia[5], // 17: secondary button (hover)
  theme.palette.rebrandBlue[3], // 18: select (hover&focus)
  theme.palette.rebrandYellow[5], // 19: hint warning variant
  theme.palette.grey[1], // 20: secondary tag border color
];

theme.palette.shadowStyle = [
  `${shadowSize[2]} ${shadowColor[1]}`, // 0: action button shadow
  `${shadowSize[1]} ${shadowColor[0]}`, // 1: job shadow
  `${shadowSize[2]} ${shadowColor[1]}`, // 2: job hover shadow
  `${shadowSize[1]} ${shadowColor[0]}`, // 3: main content shadow
  `${shadowSize[1]} ${shadowColor[0]}`, // 4: application wrapper shadow
  `${shadowSize[4]} ${shadowColor[1]}`, // 5: attachment list shadow
  `${shadowSize[3]} ${shadowColor[1]}`, // 6: attachment list hover shadow
  `${shadowSize[0]} ${shadowColor[1]}`, // 7: attachment list active shadow
  `${shadowSize[7]} ${shadowColor[4]}`, // 8: application filter shadow
  `${shadowSize[2]} ${shadowColor[1]}`, // 9: application filter hover shadow
  `${shadowSize[2]} ${shadowColor[1]}`, // 10: application filter focus shadow
  `${shadowSize[1]} ${shadowColor[0]}`, // 11: profile list shadow
  `${shadowSize[1]} ${shadowColor[0]}`, // 12: right sidebar shadow
  `${shadowSize[7]} ${shadowColor[4]}`, // 13: search bar shadow
  `${shadowSize[2]} ${shadowColor[1]}`, // 14: search bar hover shadow
  `${shadowSize[2]} ${shadowColor[1]}`, // 15: search bar focus shadow
  `${shadowSize[2]} ${shadowColor[0]}`, // 16: dropdown shadow
  `${shadowSize[7]} ${shadowColor[4]}`, // 17: sort shadow
  `${shadowSize[2]} ${shadowColor[1]}`, // 18: sort hover shadow
  `${shadowSize[5]} ${shadowColor[0]}`, // 19: job sort wrapper shadow
  `${shadowSize[5]} ${shadowColor[1]}`, // 20: job sort wrapper hover shadow
  `${shadowSize[5]} ${shadowColor[1]}`, // 21: job sort wrapper focus shadow
  `${shadowSize[0]} ${shadowColor[1]}`, // 22: page selector button shadow
  `${shadowSize[7]} ${shadowColor[4]}`, // 23: header shadow
  `${shadowSize[7]} ${shadowColor[0]}`, // 24: search bar shadow
  `${shadowSize[7]} ${shadowColor[1]}`, // 25: search bar hover shadow
  `${shadowSize[10]} ${shadowColor[7]}`, // 26: input shadow style
  `${shadowSize[12]} ${shadowColor[1]}`, // 27: seller image shadow style
  `${shadowSize[2]} ${shadowColor[9]}`, // 28: pricelist highlight
  `${shadowSize[6]} ${shadowColor[1]}`, // 29: ad type shadow
  `${shadowSize[13]} ${shadowColor[10]}`, // 30: ad type shadow (hover)
  'none', // 31: package order form container
  `${shadowSize[13]} ${shadowColor[10]}`, // 32: banner shadow
  `${shadowSize[14]} ${shadowColor[0]}`, // 33: job shadow (mobile)
  'none', // 34: breadcrumg
  `${shadowSize[7]} ${shadowColor[4]}`, // 35: invoice shadow (mobile)
  `${shadowSize[1]} ${shadowColor[0]}`, // 36: continue job notification shadow
  `none`, // 37: advanced search shadow
  `none`, // 38: advanced search shadow hover
  `none`, // 39: search and location card shadow
  'none', // 37: advanced search shadow
  'none', // 38: advanced search shadow hover
  'none', // 39: search and location card shadow
  'none', // 40: project container shadow
  'linear-gradient(to bottom, rgba(80, 80, 80, 0), rgba(80, 80, 80, 1))', // 41: profile editor item overflow shadow
  'none', // 42: profile editor action bar
  `${shadowSize[18]} ${shadowColor[16]}, ${shadowSize[19]} ${shadowColor[16]}`, // 43: profile report card shadow
];

theme.palette.borderStyle = [
  '0px', // 0: header border
  `7px solid ${theme.palette.primary[35]}`, // 1: left menu selected item;
  `1px solid ${theme.palette.dark[3]}`, // 2: divider
  `1px solid ${theme.palette.dark[3]}`, // 3: light divider
  `1px solid ${theme.palette.dark[3]}`, // 4: preselection divider
  '1px solid transparent', // 5: select tag border
  '1px solid transparent', // 6: default button border
  `1px solid ${theme.palette.dark[1]}`, // 7: alert info border
  '1px solid transparent', // 8: tooltip border
  `1px solid ${theme.palette.dark[3]}`, // 9: menu divider
  `1px solid ${theme.palette.borderColor[10]}`, // 10: subtle border
  '1px solid transparent', // 11: breadcrumb
  `1px solid rgba(177, 199, 247, 0.5)`, // 12: input bottom border
  `1px solid rgba(177, 199, 247, 0.5)`, // 13 candidate profile card border (seen)
  `1px solid rgba(77, 207, 104, 0.5)`, // 14: candidate profile card (unlocked)
  `1px solid ${theme.palette.dark[7]}`, // 15: profile list table border
  `1px solid ${theme.palette.grey[6]}`, // 16: attached components divider
  `1px solid ${theme.palette.dark[3]}`, // 17: hoverable site logo hover border
  `1px solid ${theme.palette.grey[6]}`, // 18: profile editor borders
  `1px solid ${theme.palette.rebrandYellow[3]}`, // 19: candidate profile tag borders
];

theme.palette.mobile = ['991px', '1440px', '1537px'];

theme.palette.spacing = [
  '20', // 0: layout spacing
  '20', // 1: spacing between application and sidebar
];

theme.palette.size = [
  '45', // 0: header height
  '255', // 1: sidebar width
  '330', // 2: profile list
  '320', // 3: right sidebar width
  '140', // 4: rightsidebar comment input wrapper size
  '40', // 5: application search height
  '380', // 6: application search width
  '0', // 7: actions bar
  '0', // 8: application search actions width
  '280', // 9: profile list collapsed width
  '380', // 10: right floater size
  '40', // 11: banner size
  '10', // 12: scroll size
  '2', // 13: scroll size mobile
  '400', // 14: notification list on home page
  '57', // 15: small sidebar width
];
theme.sizes = {
  bigLetters: '0.9rem',
};

theme.palette.padding = [
  '0 16px 0 12px', // 0: left menu item padding
  '0 16px 0 20px', // 1: left menu item hover padding
  '0 16px 0 5px', // 2: left menu item selected padding
];

theme.palette.focusOutline = [
  'none', // 0: radio button focus style
];

theme.palette.opacity = [
  '0.2', // 0: candidate profile card divider
  '0.55', // 1: candidate profile card time information
];

theme.primary = colors.fuchsiaDark[500];
theme.secondary = colors.blue[300];
theme.background = {
  primary: '#303030',
  panel: theme.palette.dark[1],
  panelSecondary: colors.gray[800],
  secondary: theme.palette.dark[2],
};

theme.questionMarkTooltip = {
  color: colors.gray[500],
};

theme.text = {
  primary: theme.palette.dark[5],
  gray: colors.gray[500],
  fadedGray: theme.palette.foreground[9],
  fuchsia: colors.fuchsia[600],
  darkGray: colors.gray[200],
};

theme.select = {
  tag: {
    background: {
      default: theme.palette.dark[1],
    },
    close: {
      color: {
        default: colors.blue[500],
      },
    },
  },
  notFoundContent: {
    text: {
      color: {
        default: colors.gray[500],
      },
    },
  },
  filters: {
    border: {
      default: {
        color: theme.palette.dark[1],
      },
      hover: {
        color: theme.palette.dark[1],
      },
      focus: {
        color: theme.palette.dark[1],
      },
    },
  },
};

theme.optionBox = {
  outline: {
    default: 'transparent',
    hover: colors.fuchsia[600],
    selected: colors.blue[500],
  },
  background: {
    default: theme.palette.dark[3],
    borderless: theme.palette.dark[3],
    selected: theme.palette.dark[1],
    filled: theme.palette.dark[3],
    gradient: colors.yellow[200],
    hover: {
      gradient: colors.fuchsia[600] + '26',
    },
  },
  separator: {
    default: colors.blue[200],
  },
  text: {
    color: {
      default: theme.text.primary,
    },
    background: {
      highlight: theme.palette.dark[2],
    },
  },
  pill: {
    background: colors.grayDark[200],
    borderColor: colors.blue[200],
  },
  yellowPopover: {
    background: theme.palette.dark[3],
    color: {
      default: colors.blue[100],
      light: theme.palette.dark[5],
    },
    borderColor: colors.blue[200],
    boxShadow: `0 3px 6px -4px rgba(30, 46, 92, 0.35),
                0 6px 16px 0 rgba(30, 46, 92, 0.32),
                0 9px 28px 8px rgba(30, 46, 92, 0.25);`,
  },
};

theme.input = {
  padding: '8px 8px',
  fontSize: '0.8rem',
  background: {
    error: theme.palette.dark[3],
  },
};

theme.hint = {
  info: {
    background: colors.grayDark[200],
    color: colors.blue[300],
    border: colors.blue[300],
  },
  warning: {
    background: colors.grayDark[200],
    color: colors.yellow[600],
    border: colors.yellow[600],
  },
  success: {
    background: colors.grayDark[200],
    color: colors.green[500],
    border: colors.green[500],
  },
  error: {
    background: colors.grayDark[200],
    color: colors.red[400],
    border: colors.red[400],
  },
};

theme.tag = {
  background: {
    default: colors.blue[50],
    nonClickable: theme.palette.dark[1],
  },
  text: {
    color: {
      default: colors.blue[600],
      nonClickable: colors.gray[100],
    },
  },
  border: {
    default: colors.blue[200],
    nonClickable: theme.palette.dark[1],
  },
};

theme.slider = {
  background: {
    default: colors.blue[600],
  },
  text: {
    color: {
      default: theme.palette.dark[5],
    },
  },
  border: {
    default: colors.blue[600],
  },
  rail: {
    default: colors.blue[100],
  },
};

theme.preselection = {
  background: colors.grayDark[500],
  questionHover: colors.grayDark[600],
  border: {
    disabled: colors.grayDark[200],
    expanded: colors.gray[600],
    collapsed: theme.background.panel,
  },
  answer: {
    background: {
      preferable: colors.green[800],
      nonPreferable: colors.red[800],
    },
  },
  suggestedQuestion: {
    added: {
      borderColor: {
        regular: colors.blue[600],
        hovered: colors.blue[500],
      },
      background: {
        regular: colors.infoBlueDark[900],
        hovered: colors.infoBlueDark[800],
      },
      textColor: colors.blue[200],
    },
    notAdded: {
      borderColor: {
        regular: colors.gray[600],
        hovered: colors.gray[500],
      },
      background: {
        regular: colors.grayDark[500],
        hovered: colors.grayDark[300],
      },
      textColor: theme.text.primary,
    },
  },
};

theme.socialPostingOption = {
  background: {
    default: theme.background.primary,
    selected: theme.palette.dark[1],
  },
  circle: {
    default: theme.palette.dark[3],
  },
};

theme.steps = {
  background: {
    active: colors.fuchsia[600],
    inactive: colors.grayDark[900],
  },
};

theme.stars = {
  color: {
    full: colors.yellow[500],
    empty: colors.grayDark[700],
  },
};

theme.inviteFlow = {
  tooltipBackground: colors.grayDark[800],
  text: colors.gray[100],
  textMuted: colors.gray[400],
  textActive: colors.gray[50],
  stageBackground: `linear-gradient(120deg, ${colors.grayDark[900]} 45%, color-mix(in srgb, ${colors.blue[200]} 20%, ${colors.grayDark[900]}) 100%)`,
  icon: colors.blue[300],
  track: colors.gray[700],
  accent: colors.fuchsiaDark[400],
  accentStrong: colors.fuchsiaDark[600],
  surface: colors.grayDark[800],
  placeholder: colors.gray[700],
  accept: colors.green[500],
  free: colors.green[400],
  declineBackground: colors.grayDark[200],
  rowBackground: colors.grayDark[700],
  rowBorder: colors.grayDark[200],
  newRowBackground: `color-mix(in srgb, ${colors.green[700]} 30%, ${colors.grayDark[700]})`,
  newRowBorder: colors.green[700],
  newRowPlaceholder: colors.green[500],
};

theme.modal = {
  closeIcon: {
    background: colors.grayDark[400],
    color: colors.gray[200],
  },
  shadow: {
    default: '0px 16px 28px -3px hsl(0deg 0% 0%), 0px 4px 4px 0px hsl(0deg 0% 0% / 15%)',
  },
};

theme.statistic = {
  color: {
    title: theme.text.gray,
    value: theme.text.primary,
    prefix: theme.text.primary,
    suffix: theme.text.primary,
    dateIcon: colors.fuchsia[500],
  },
  selectionLevel: {
    track: colors.grayDark[600],
    label: theme.text.primary,
    reached: colors.blue[200],
    current: colors.blue[600],
    // `dark` for the count standing on `reached`, `light` for the one on `current`.
    count: {
      dark: colors.gray[900],
      light: '#FFFFFF',
    },
  },
  shadow: {
    statistic: '0px 4px 9px 0px rgba(211, 219, 251, 0.1)',
  },
};

theme.newRadioButtons = {
  /* a neutral hairline rather than blue[200]: a near-white blue outline made the
     group the loudest line on the page */
  border: colors.grayDark[200],
  text: theme.palette.dark[5],
  /* checked must read LIGHTER than unchecked here. The unchecked background is
     `background[83]` -> dark[3] (#343230), so the previous dark[1] (#191919)
     inverted the affordance: the selected option looked like the inactive one. */
  background: colors.infoBlueDark[700],
};

theme.newDiscountTable = {
  border: colors.blue[200],
  cellText: theme.palette.dark[5],
  cellBackground: theme.palette.dark[1],
};

theme.faqAccordion = {
  border: `1px solid ${colors.blue[150]}`,
  textColor: colors.blue[50],
};

theme.discountPicker = {
  background: colors.grayDark[900],
  borderRadius: '12px',
  borderColor: {
    blue: colors.blue[900],
    gray: colors.gray[700],
  },
  durationToggle: {
    background: colors.blue[900],
  },
  textColor: {
    primary: colors.blue[200],
    secondary: colors.blue[600],
    label: colors.gray[200],
  },
};

theme.highlightTag = {
  background: colors.yellow[500],
  color: colors.blue[900],
};

theme.toggle = {
  background: {
    default: colors.grayDark[600],
    indicator: colors.blue[600],
    hover: colors.grayDark[800],
  },
  color: {
    active: 'white',
    inactive: colors.blue[400],
  },
};

theme.welcomePackage = {
  background: colors.grayDark[300],
  textColor: 'tomato',
  timer: {
    color: colors.blue[300],
    borderColor: colors.blue[300],
    borderRadius: '12px',
  },
  banner: {
    background: {
      packages: colors.grayDark[600],
      bundle: 'transparent',
    },
    borderColor: colors.blue[200],
  },
};

theme.yellowUnderline = colors.blue[900];

theme.sideMenu = {
  highlight: colors.blue[900],
};

theme.welcomePackage = {
  background: colors.grayDark[300],
  textColor: 'tomato',
  timer: {
    color: colors.blue[300],
    borderColor: colors.blue[300],
    borderRadius: '12px',
  },
  banner: {
    background: {
      packages: colors.grayDark[600],
      bundle: 'transparent',
    },
    borderColor: colors.blue[200],
  },
};

theme.yellowUnderline = colors.blue[900];

theme.sideMenu = {
  highlight: colors.blue[900],
};

theme.survey = {
  page: {
    color: colors.gray[400],
    shadow: 'none',
    background: colors.grayDark[400],
    borderColor: colors.gray[600],
  },
  question: {
    color: colors.blue[900],
    background: colors.blue[300],
    borderColor: colors.blue[300],
    answerColor: colors.gray[400],
    borderRadius: '8px',
    padding: {
      large: '1.875rem',
      small: '0.875rem',
    },
    shadow:
      '0px 16px 28px -3px hsla(222, 83%, 34%, 0.27), 0px 4px 4px 0px hsla(222, 83%, 34%, 0.15)',
    completed: {
      color: colors.green[900],
      background: colors.green[400],
      borderColor: colors.green[400],
    },
  },
};

/**
 * The anonymous survey page (containers/GenericSurvey). Not the old survey above.
 * Same dark recipe as theme.dashboard below, so the page looks like the app it belongs to:
 * the card is a dashboard widget, boxes inside it lift like the widget's inner cards, text is
 * white at 0.85 / 0.55, and the progress bar uses the package-balance track and fill.
 */
theme.genericSurvey = {
  border: 'rgba(255, 255, 255, 0.12)',
  card: {
    background: colors.grayDark[700],
    shadow: 'none',
  },
  input: {
    background: colors.grayDark[500],
  },
  loader: colors.blue[500],
  option: {
    hoverBorder: colors.blue[400],
    selectedBackground: colors.grayDark[400],
    selectedBorder: colors.blue[300],
  },
  page: {
    background: theme.palette.dark[1],
  },
  progress: {
    bar: colors.blue[400],
    rail: colors.grayDark[400],
  },
  // Filled, like the active chart column: a lifted box alone would not read as selected.
  rating: {
    selectedBackground: colors.blue[300],
    selectedColor: colors.blue[900],
  },
  text: {
    muted: 'rgba(255, 255, 255, 0.55)',
    primary: 'rgba(255, 255, 255, 0.85)',
    // A step deeper than the title, like the dashboard's subtitle under its title.
    question: colors.blue[200],
    // The dashboard's header title colour (DashboardHeaderTitle), so it stands apart from body text.
    title: colors.blue[100],
  },
  thankYou: {
    iconBackground: colors.green[800],
    iconColor: colors.green[100],
  },
};

/**
 * Smart sort summary card as rendered in the single application view (design 1b).
 * The card sits a hair lighter than the application background (palette.dark[2], #242424),
 * mirroring the design's shell-to-card lift.
 */
theme.smartSortSummary = {
  background: colors.grayDark[500],
  borderColor: theme.palette.dark[8],
  titleColor: theme.palette.dark[4],
  bodyColor: colors.gray[500],
  mutedColor: colors.gray[600],
};

theme.applicationsList = {
  header: {
    height: '52px',
  },
  rating: {
    popover: {
      titleColor: colors.blue[300],
      starsBackground: colors.gray[600],
      userStarsBackground: colors.gray[600],
      userBackground: colors.grayDark[600],
      borderColor: colors.grayDark[600],
    },
  },
  singleApplication: {
    default: {
      phoneColor: colors.blue[300],
    },
    selected: {
      background: colors.blue[900],
      phoneColor: colors.blue[100],
      rejected: {
        applicantName: colors.gray[500],
      },
    },
  },
};

theme.popoverButton = {
  color: theme.text.primary,
  backgroundColor: 'unset',
  borderColor: theme.text.primary,
  shadow: '0px 3px 6px -4px #537bd51f, 0px 6px 16px 0px #537bd514, 0px 9px 28px 8px #537bd50d',
};

theme.scheduledActions = {
  accent: colors.green[400],
  idle: colors.gray[500],
  category: {
    rejection: colors.fuchsia[300],
    interview: colors.blue[300],
    thankYou: colors.green[300],
    other: colors.gray[400],
  },
  glow: transparentize(0.4, colors.green[400]),
  badgeText: colors.grayDark[900],
  flightIcon: colors.grayDark[900],
  flightShadow: '0 6px 18px rgba(0, 0, 0, 0.6)',
  rowBackground: colors.grayDark[400],
  rowBorder: colors.grayDark[200],
  iconBackground: transparentize(0.8, colors.green[400]),
  text: colors.gray[100],
  textMuted: colors.gray[400],
};

// Tab that pulls the right sidebar over the application while it is maximized.
theme.rightSidebarHandle = {
  background: theme.palette.dark[8],
  border: theme.palette.dark[3],
  color: theme.text.primary,
  focusRing: colors.blue[400],
  hover: {
    background: theme.palette.dark[3],
    color: theme.palette.dark[4],
  },
  shadow: '-4px 0px 16px -8px #00000099, -1px 0px 4px -2px #0000005c',
};

theme.newsFeedItem = {
  flashingBackgroundColor: colors.grayDark[200],
  unread: {
    background: {
      default: colors.grayDark[500],
      hover: colors.grayDark[500],
    },
    title: theme.text.primary,
    content: theme.text.gray,
    border: '2px solid transparent',
    icon: {
      default: colors.fuchsia[600],
    },
  },
  read: {
    background: {
      default: colors.grayDark[200],
      hover: colors.grayDark[500],
    },
    title: colors.gray[600],
    content: colors.gray[400],
    border: `2px solid ${colors.gray[100]}`,
    icon: {
      default: colors.gray[700],
      hover: theme.text.primary,
    },
  },
};

theme.notificationItem = {
  title: theme.text.primary,
  date: theme.text.primary,
  content: colors.gray[500],
  border: {
    hover: colors.blue[800],
  },
  unread: {
    background: {
      default: colors.grayDark[500],
      hover: colors.grayDark[500],
    },
  },
  read: {
    background: {
      default: colors.grayDark[200],
      hover: colors.grayDark[500],
    },
  },
};

theme.animatedBanner = {
  background: 'rgba(80, 80, 80, 0.25)',
  yellow: colors.yellow[800],
  purple: colors.purple[800],
};

theme.calendar = {
  slot: {
    accepted: {
      backgroundColor: colors.blue[100],
      textColor: colors.blue[800],
      separatorColor: colors.blue[700],
      highlightColor: colors.blue[150],
      iconColor: colors.blue[800],
    },
    rejected: {
      backgroundColor: '#FBE4EA',
      textColor: colors.fuchsia[600],
      separatorColor: colors.fuchsia[600],
      highlightColor: '#F7C9D580',
      iconColor: colors.fuchsia[600],
    },
    cancelled: {
      backgroundColor: '#FBE4EA',
      textColor: colors.fuchsia[600],
      separatorColor: colors.fuchsia[600],
      highlightColor: '#F7C9D580',
      iconColor: colors.fuchsia[600],
    },
    action_required: {
      backgroundColor: colors.yellow[100],
      textColor: colors.yellow[800],
      separatorColor: colors.yellow[600],
      highlightColor: '#FFE5A099',
      iconColor: colors.yellow[800],
    },
    pending: {
      backgroundColor: colors.blue[100],
      textColor: colors.blue[800],
      separatorColor: colors.blue[700],
      highlightColor: colors.blue[150],
      iconColor: colors.gray[600],
    },
  },
  reason: {
    edit: {
      backgroundColor: colors.yellow[900],
      accentColor: colors.yellow[700],
    },
    reject: {
      backgroundColor: colors.red[900],
      accentColor: colors.red[500],
    },
    cancel: {
      backgroundColor: colors.blue[50],
      accentColor: theme.text.primary,
    },
  },
  previewStatus: {
    accepted: {
      textColor: colors.green[800],
      borderColor: colors.green[200],
      backgroundColor: colors.green[50],
    },
    pending: {
      textColor: colors.blue[700],
      borderColor: colors.blue[150],
      backgroundColor: colors.blue[50],
    },
    rejected: {
      textColor: colors.fuchsia[700],
      borderColor: colors.red[100],
      backgroundColor: colors.red[50],
    },
    cancelled: {
      textColor: colors.fuchsia[700],
      borderColor: colors.red[100],
      backgroundColor: colors.red[50],
    },
    action_required: {
      textColor: colors.yellow[900],
      borderColor: colors.yellow[200],
      backgroundColor: colors.yellow[50],
    },
  },
};

theme.promoCodeInput = {
  background: colors.grayDark[400],
  color: 'rgba(255, 255, 255, 0.7)',
  borderColor: colors.grayDark[400],
  inputBackground: colors.grayDark[800],
  inputColor: 'rgba(255, 255, 255, 0.7)',
};

/* the far stop is blue[200] blended down into the card base — a full-strength
   #B1C7F7 would swallow the blue[300] label sitting on top of it */
const sidemenuCardGradient = `linear-gradient(120deg, ${colors.grayDark[900]} 45%, color-mix(in srgb, ${colors.blue[200]} 20%, ${colors.grayDark[900]}) 100%)`;

theme.packagesSidemenu = {
  card: {
    default: {
      background: colors.grayDark[900],
      color: colors.gray[500],
      borderColor: colors.grayDark[600],
      chervonColor: colors.blue[300],
    },
    hover: {
      background: sidemenuCardGradient,
      color: colors.fuchsiaDark[400],
      borderColor: colors.fuchsiaDark[400],
      chervonColor: colors.fuchsiaDark[400],
    },
    active: {
      background: sidemenuCardGradient,
      color: colors.blue[300],
      borderColor: colors.grayDark[600],
      chervonColor: colors.blue[300],
    },
  },
  dropdown: {
    background: colors.grayDark[600],
    color: colors.blue[300],
    borderColor: colors.grayDark[600],
    iconHoverColor: colors.fuchsia[700],
  },
  confirmPulse: {
    ringStrong: `color-mix(in srgb, ${colors.blue[500]} 55%, transparent)`,
    ringSoft: `color-mix(in srgb, ${colors.blue[500]} 28%, transparent)`,
  },
};

theme.orderedPackages = {
  color: colors.blue[100], // light text for dark backgrounds
  borderColor: colors.grayDark[400], // subtle dark border
  header: {
    background: colors.grayDark[500], // dark header background
  },
  footer: {
    background: colors.grayDark[400], // dark footer background
  },
};

theme.packageOrderForm = {
  sectionTitleColor: theme.palette.dark[5],
  adLengthLabelColor: colors.gray[400],
  descriptionColor: theme.palette.foreground[100],
  cta: {
    background: colors.fuchsia[600],
    hoverBackground: colors.fuchsiaDark[500],
    activeBackground: colors.fuchsiaDark[600],
    focusRing: colors.fuchsiaDark[300],
  },
};

theme.packagesBanner = {
  // dark[2] is the same variable MainContent resolves to, so the banner sits
  // flush with the section instead of bleeding into the shell above it
  background: theme.palette.dark[2],
  titleColor: theme.palette.dark[5],
};

theme.packageCard = {
  color: colors.gray[500],
  topBackground: colors.grayDark[600],
  background: colors.grayDark[400],
  borderColor: colors.grayDark[700],
  seperatorColor: colors.grayDark[500],
  status: {
    active: {
      color: colors.blue[900],
      background: colors.green[600],
    },
    pending: {
      color: colors.blue[800],
      background: colors.yellow[500],
    },
  },
};

theme.packagesOrderSummary = {
  shadow: '0 -1px 3px rgba(0, 0, 0, 0.35), 0 -10px 24px rgba(0, 0, 0, 0.16)',
  slider: {
    background: colors.grayDark[700],
    borderColor: colors.grayDark[400],
    color: colors.gray[200],
  },
  summary: {
    background: colors.grayDark[500],
    hoverBackground: colors.grayDark[400],
    color: colors.blue[200],
    borderColor: colors.grayDark[400],
    action: colors.blue[300],
  },
  ribbon: {
    background: colors.grayDark[600],
    color: colors.blue[100],
    borderColor: colors.grayDark[600],
    badgeBackground: colors.fuchsia[600],
    shadow: '0 -3px 8px rgba(0, 0, 0, 0.25)',
  },
  freshRow: {
    background: colors.blue[900],
  },
  fx: {
    rippleColor: colors.blue[400],
    splashColor: colors.blue[800],
    // pageFlash: reserved for the add-to-cart background flash (designer asset pending)
  },
};

theme.packagesNavigation = {
  mobile: {
    default: {
      color: colors.gray[300],
      borderColor: colors.gray[300],
    },
    selected: {
      color: colors.fuchsia[600],
      borderColor: colors.fuchsia[600],
    },
    hover: {
      background: colors.grayDark[500],
    },
  },
};

theme.quickFilter = {
  background: {
    default: theme.palette.dark[3],
    selected: theme.palette.dark[3],
    negative: colors.red[100],
  },
  color: {
    default: theme.palette.dark[5],
    negative: colors.red[600],
  },
  border: {
    default: theme.palette.dark[7],
    selected: theme.palette.dark[6],
    negative: colors.red[600],
  },
};

theme.dailyChart = {
  addonRectColors: {
    social_posting_poslovi_fb: colors.purple[500],
    social_posting_poslovi_instagram: colors.fuchsia[400],
    social_posting_helloworld_fb: colors.purple[500],
    social_posting_helloworld_instagram: colors.fuchsia[400],
    top_result: colors.yellow[500],
    highlighted_ad: colors.blue[600],
  },
  addonDateRangeColors: {
    social_posting_poslovi_fb: colors.purple[300],
    social_posting_poslovi_instagram: colors.fuchsia[200],
    social_posting_helloworld_fb: colors.purple[300],
    social_posting_helloworld_instagram: colors.fuchsia[200],
    top_result: colors.yellow[200],
    highlighted_ad: colors.blue[200],
  },
};

theme.interviewQuestions = {
  hoverColor: colors.fuchsia[400],
  activeColor: colors.blue[400],
  tabs: {
    descriptionColor: colors.gray[600],
  },
  addQuestionSection: {
    otherLanguageBackground: {
      active: colors.gray[800],
      hidden: colors.grayDark[400],
    },
    borderColor: colors.grayDark[200],
  },
  question: {
    background: colors.grayDark[400],
    color: colors.gray[500],
    ai: {
      background: 'linear-gradient(135deg, #1d3768ff, #432c7aff)',
      color: colors.blue[300],
    },
    actions: {
      color: colors.blue[400],
      hoverColor: colors.fuchsia[600],
    },
    save: {
      color: colors.fuchsia[600],
    },
    title: {
      borderColor: colors.blue[100],
    },
    feedback: {
      color: colors.gray[600],
      hover: colors.fuchsia[600],
      active: colors.blue[400],
    },
    answer: {
      color: colors.gray[100],
    },
  },
};

theme.applicationsSelection = {
  background: colors.grayDark[200],
  header: {
    boxShadow: 'none',
    edit: {
      color: colors.blue[500],
    },
    count: {
      background: colors.blue[100],
      color: colors.blue[700],
    },
  },
  column: {
    background: colors.grayDark[500],
  },
  hiredPrompt: {
    title: {
      color: colors.gray[400],
    },
    dropZone: {
      activeBackground: colors.grayDark[400],
      background: colors.grayDark[600],
      border: colors.yellowDark[400],
      hint: {
        color: colors.gray[500],
      },
      icon: {
        background: colors.grayDark[400],
        color: colors.yellowDark[400],
      },
      title: {
        color: colors.gray[200],
      },
    },
    motion: {
      card: colors.grayDark[300],
      cursor: colors.gray[500],
      line: colors.gray[700],
      lineSoft: colors.gray[800],
      shadow: 'rgba(0, 0, 0, 0.45)',
    },
    notHired: {
      color: colors.gray[400],
    },
  },
  item: {
    name: {
      default: {
        color: colors.fuchsia[400],
      },
      rejected: {
        color: colors.gray[500],
      },
      read: {
        color: colors.gray[100],
      },
    },
    phone: {
      color: colors.blue[200],
    },
    applicationTime: {
      color: colors.gray[400],
    },
    // The border-trace effect a card plays when it lands in Hired, tuned for the dark card.
    justHired: {
      glow: 'rgba(102, 187, 185, 0.30)',
      head: colors.green[600],
      trace: colors.green[400],
    },
    previousActions: {
      color: colors.gray[600],
    },
    quickActions: {
      boxShadow: '0px 16px 28px -3px #0f3a9f80',
    },
  },
};

theme.dashboard = {
  widget: {
    background: colors.grayDark[700],

    jobList: {
      titleColor: 'rgba(255, 255, 255, 0.7)',
      linkColor: colors.fuchsia[600],
    },

    newsFeed: {
      titleColor: 'rgba(255, 255, 255, 0.7)',
      titleScrimColor: 'rgba(255, 255, 255, 0.7)',
      externalIconColor: 'rgba(255, 255, 255, 0.7)',
      externalIconBackground: 'rgba(20, 23, 33, 0.7)',
      emptyColor: 'rgba(255, 255, 255, 0.55)',
      overlayGradient:
        'linear-gradient(198.42deg, rgba(255, 229, 160, 0.06) 16.66%, rgba(20, 23, 33, 0.5) 64.45%, rgba(3, 26, 106, 0.88) 96.8%)',
    },

    jobPackageBalance: {
      titleColor: 'rgba(255, 255, 255, 0.85)',
      linkColor: 'rgba(255, 255, 255, 0.85)',
      linkBackground: colors.grayDark[500],
      cardBackground: colors.grayDark[500],
      iconBubbleBackground: colors.grayDark[700],
      iconBubbleColor: 'rgba(255, 255, 255, 0.85)',
      packageNameColor: 'rgba(255, 255, 255, 0.85)',
      dateLineColor: 'rgba(255, 255, 255, 0.55)',
      progressTrack: colors.grayDark[400],
      progressFill: colors.blue[400],
      progressLabelColor: 'rgba(255, 255, 255, 0.7)',
      progressEndsColor: 'rgba(255, 255, 255, 0.45)',
      savingsBackground: colors.grayDark[500],
      savingsText: 'rgba(255, 255, 255, 0.85)',
      renewPillBg: colors.grayDark[500],
      renewPillText: 'rgba(255, 255, 255, 0.85)',
      chartTitleColor: 'rgba(255, 255, 255, 0.55)',
      chartColumn: colors.blue[500],
      chartColumnActive: colors.blue[300],
      chartColumnEmpty: 'rgba(255, 255, 255, 0.12)',
      chartAxisLabel: 'rgba(255, 255, 255, 0.55)',
      chartTooltipBackground: colors.grayDark[200],
      chartTooltipText: '#FFFFFF',
      status: {
        active: { bg: colors.green[800], fg: colors.green[100] },
        soon: { bg: colors.fuchsia[900], fg: colors.fuchsia[100] },
        expired: { bg: colors.grayDark[400], fg: 'rgba(255, 255, 255, 0.7)' },
      },
    },
  },
};

/* The savings ramp in dark: an amber wash over the chip that thickens with the
   discount, rather than the light theme's solid fills — a full-strength yellow at
   this size becomes the brightest object on the screen and out-shouts the CTA. */
const upsellRampAmber = '255, 205, 68';

theme.quantityUpsell = {
  card: {
    background: colors.grayDark[800],
    border: colors.grayDark[400],
    shadow: 'none',
    color: colors.gray[200],
  },
  price: {
    color: colors.blue[300],
    currencyColor: colors.blue[400],
    label: colors.gray[500],
  },
  progress: {
    track: colors.grayDark[400],
    fill: colors.blue[500],
    label: colors.gray[500],
  },
  nudge: {
    color: colors.blue[200],
    bestColor: colors.green[300],
  },
  chip: {
    background: colors.grayDark[600],
    border: colors.grayDark[300],
    shadow: 'none',
    numberColor: colors.gray[100],
    unitColor: colors.gray[500],
    focusRing: colors.blue[400],
    /* dark has no light-blue fill to borrow from the option cards, so selection is
       the same idea in this theme's terms: a blue wash over the chip plus the ring
       the option cards already select with */
    selected: {
      background: 'rgba(83, 123, 213, 0.18)',
      border: theme.optionBox.outline.selected,
    },
    pill: {
      rampFrom: `rgba(${upsellRampAmber}, 0.08)`,
      rampTo: `rgba(${upsellRampAmber}, 0.44)`,
      color: colors.yellowDark[200],
    },
    micro: {
      suggested: colors.yellowDark[300],
    },
    check: {
      background: colors.blue[500],
      color: '#ffffff',
      shadow: 'none',
    },
  },
  stepper: {
    label: colors.gray[400],
    background: colors.grayDark[600],
    buttonBorder: colors.grayDark[300],
    buttonBackground: colors.grayDark[600],
    buttonColor: colors.gray[200],
    buttonHoverBorder: colors.blue[500],
    buttonHoverColor: '#ffffff',
    buttonDisabledColor: colors.gray[700],
    valueBorder: colors.grayDark[200],
    valueColor: '#ffffff',
    divider: colors.grayDark[400],
    focusRing: colors.blue[400],
  },
  total: {
    oldPrice: colors.gray[600],
    newPrice: '#ffffff',
    currency: colors.gray[500],
    badgeBackground: `rgba(${upsellRampAmber}, 0.20)`,
    badgeColor: colors.yellowDark[200],
  },
};

theme.hrReport = {
  card: {
    background: colors.grayDark[700],
    border: colors.grayDark[400],
    shadow: '0 1px 2px rgba(0, 0, 0, 0.35)',
    titleColor: 'rgba(255, 255, 255, 0.85)',
    subtitleColor: 'rgba(255, 255, 255, 0.55)',
  },
  kpi: {
    background: colors.grayDark[700],
    shadow: '0 1px 2px rgba(0, 0, 0, 0.35)',
    labelColor: 'rgba(255, 255, 255, 0.55)',
    valueColor: 'rgba(255, 255, 255, 0.85)',
    iconBackground: colors.grayDark[500],
    iconColor: colors.blue[300],
    delta: {
      positive: { color: colors.green[300], background: colors.green[900] },
      negative: { color: colors.red[300], background: colors.red[900] },
      neutral: { color: 'rgba(255, 255, 255, 0.55)', background: colors.grayDark[500] },
    },
  },
  funnel: {
    labelColor: 'rgba(255, 255, 255, 0.85)',
    trackBackground: colors.grayDark[400],
    countColor: '#FFFFFF',
    conversionColor: 'rgba(255, 255, 255, 0.55)',
    palette: [
      colors.blue[400],
      colors.blue[300],
      colors.purple[400],
      colors.fuchsiaDark[300],
      colors.fuchsiaDark[500],
    ],
  },
  barList: {
    labelColor: 'rgba(255, 255, 255, 0.85)',
    valueColor: 'rgba(255, 255, 255, 0.85)',
    trackBackground: colors.grayDark[400],
    defaultFill: colors.blue[400],
  },
  metricToggle: {
    trackBackground: colors.grayDark[500],
    itemColor: 'rgba(255, 255, 255, 0.7)',
    activeBackground: colors.grayDark[700],
    activeColor: 'rgba(255, 255, 255, 0.9)',
    activeShadow: '0 1px 3px rgba(0, 0, 0, 0.45)',
  },
  table: {
    headerBackground: colors.grayDark[500],
    headerColor: 'rgba(255, 255, 255, 0.55)',
    rowBorder: colors.grayDark[400],
    cellColor: 'rgba(255, 255, 255, 0.85)',
    emphasisColor: colors.fuchsiaDark[300],
    sortIconColor: 'rgba(255, 255, 255, 0.35)',
    sortIconActiveColor: colors.fuchsiaDark[300],
    hoverBackground: colors.grayDark[500],
    headerHoverBackground: colors.grayDark[400],
    headerSortedBackground: colors.grayDark[400],
    cellSortedBackground: colors.grayDark[600],
  },
  search: {
    background: colors.grayDark[500],
    border: 'rgba(255, 255, 255, 0.16)',
    hoverBorder: 'rgba(255, 255, 255, 0.32)',
    focusBorder: colors.blue[300],
    focusShadow: '0 0 0 2px rgba(146, 174, 236, 0.2)',
    color: 'rgba(255, 255, 255, 0.85)',
    placeholderColor: 'rgba(255, 255, 255, 0.4)',
    iconColor: 'rgba(255, 255, 255, 0.4)',
    iconHoverColor: 'rgba(255, 255, 255, 0.75)',
  },
  chart: {
    axisLabel: 'rgba(255, 255, 255, 0.55)',
    gridLine: 'rgba(255, 255, 255, 0.12)',
    tooltipBackground: colors.grayDark[200],
    tooltipColor: '#FFFFFF',
    areaGradientOpacity: 0.28,
    series: [
      colors.blue[400],
      colors.blue[300],
      colors.fuchsiaDark[400],
      colors.purple[400],
      colors.green[400],
      colors.yellowDark[400],
    ],
  },
  emptyState: {
    color: 'rgba(255, 255, 255, 0.55)',
    iconColor: 'rgba(255, 255, 255, 0.25)',
  },
  skeleton: {
    /** Highlight band swept across loading placeholders — lighter than the flat track. */
    highlight: 'rgba(255, 255, 255, 0.09)',
  },
};

// Brand-coloured on purpose in both themes: the demo bar must read as "not part of the app".
theme.demoBar = {
  background: colors.blue[900],
  color: '#FFFFFF',
  shadow: '0 4px 16px rgba(13, 48, 130, 0.25)',
};

export default theme;
